import { render } from "./RightSidebarClienteFilter.vue?vue&type=template&id=3610ad78"
import script from "./RightSidebarClienteFilter.vue?vue&type=script&lang=js"
export * from "./RightSidebarClienteFilter.vue?vue&type=script&lang=js"

import "./RightSidebarClienteFilter.vue?vue&type=style&index=0&id=3610ad78&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__